import {
	DELETE_STREAM_MARKER,
	UPDATE_STREAM_MARKER,
	DELETE_STREAM_MARKER_COMPLETE,
	UPDATE_STREAM_MARKER_COMPLETE,
	DELETE_STREAM,
	DELETE_STREAM_COMPLETE,
	SAVE_STREAM_COMPLETE,
	SAVE_STREAM,
	GET_STREAMS_COMPLETE,
	GET_STREAMS,
	GET_PROVIDER_SRC,
	GET_PROVIDER_SRC_COMPLETE,
	TOGGLE_STREAM_OPEN,
	SET_TIME_SKIP,
	RESET_TIME_SKIP,
	SET_POPOUT_OPEN,
	SET_POPOUT_CLOSED,
	SET_STREAM_EVENT_ID
} from "./constants";
import { stateSyncEventMatch } from "../../store/middlewares/state-sync-middleware";

const initialState = {
	streams: [],
	isLoading: false,
	open: false,
	timeSkip: null,
	popoutOpen: false,
	eventId: null
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case GET_PROVIDER_SRC:
		case GET_STREAMS:
		case DELETE_STREAM:
		case SAVE_STREAM:
		case UPDATE_STREAM_MARKER:
		case DELETE_STREAM_MARKER:
			return { ...state, isLoading: true };
		case SET_STREAM_EVENT_ID:
			return { ...state, ...payload, isLoading: false };
		case GET_STREAMS_COMPLETE:
		case SET_TIME_SKIP:
		case RESET_TIME_SKIP:
		case SET_POPOUT_OPEN:
		case SET_POPOUT_CLOSED:
		case TOGGLE_STREAM_OPEN:
			return stateSyncEventMatch(
				state.eventId,
				payload.eventId,
				{ ...state },
				{
					...state,
					...payload,
					isLoading: false
				}
			);

		case UPDATE_STREAM_MARKER_COMPLETE:
		case DELETE_STREAM_MARKER_COMPLETE: {
			const { stream } = payload;
			const updatedStreams = state.streams.map((s) => {
				if (s.id === stream.id) {
					return stream;
				}
				return s;
			});
			return stateSyncEventMatch(
				state.eventId,
				payload.eventId,
				{ ...state },
				{
					...state,
					isLoading: false,
					streams: updatedStreams
				}
			);
		}
		case SAVE_STREAM_COMPLETE: {
			const { stream } = payload;
			const isNewStream = !state.streams.some((s) => s.id === stream.id);
			if (isNewStream) {
				return stateSyncEventMatch(
					state.eventId,
					payload.eventId,
					{ ...state },
					{
						...state,
						isLoading: false,
						streams: [...state.streams, stream]
					}
				);
			}
			return stateSyncEventMatch(
				state.eventId,
				payload.eventId,
				{ ...state },
				{
					...state,
					isLoading: false,
					streams: state.streams.map((s) => {
						if (s.id === stream.id) {
							return stream;
						}
						return s;
					})
				}
			);
		}
		case DELETE_STREAM_COMPLETE:
			return stateSyncEventMatch(
				state.eventId,
				payload.eventId,
				{ ...state },
				{
					...state,
					isLoading: false,
					streams: state.streams.filter((s) => s.id !== payload.streamId)
				}
			);
		case GET_PROVIDER_SRC_COMPLETE: {
			const { updatedStream } = payload;

			return {
				...state,
				isLoading: false,
				streams: state.streams.map((s) => {
					if (s.id === updatedStream.id) {
						return updatedStream;
					}
					return s;
				})
			};
		}
		default:
			return state;
	}
};

export default reducer;
